import Vue from 'vue';
import { addClass } from '@/common/utils/CommonFn.js'
/**权限指令**/
Vue.directive('has', {
  bind: function (el, binding,vnode) {
    if (!Vue.prototype.$_has(binding.value,vnode.context.$route.meta.btnPermissions)) {
      setTimeout(() => el.parentNode.removeChild(el))
    }
  }
});
Vue.directive('disabled', {
  bind: function (el, binding,vnode) {
    if (!Vue.prototype.$_has(binding.value,vnode.context.$route.meta.btnPermissions)) {
      el.disabled = true
      addClass(el, 'is-disabled')
    }
  }
});
// 权限检查方法
Vue.prototype.$_has = function (value,btnPermissionsArr) {
  let isExist = false;
  if (btnPermissionsArr == undefined || btnPermissionsArr == null) {
    return false;
  }
  for (let i = 0; i < btnPermissionsArr.length; i++) {
    if (value == btnPermissionsArr[i]) {
      isExist = true;
      break;
    }
  }
  return isExist;
};



// WEBPACK FOOTER //
// ./src/directive/btn-permission/directives.js